<template>
    <div class="item" v-if="memberInfo.mem_type != 1">
        <div class="switch-sip-wrap">
            <!-- 切换座席 -->
            <el-dropdown v-if="currentSeat" trigger="click">
                <span class="el-dropdown-link">
                    <!-- (${currentSeat.link_type == 2 ? '预测' : '普通'}) -->
                    {{ `${currentSeat.voipaccount}` }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <!-- (${item.link_type == 2 ? '预测' : '普通'}) -->
                    <el-dropdown-item v-for="item in seats" :key="item.id" @click.native="handleSwitchSip(item)">{{ `${item.voipaccount}` }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <!-- 预测式状态 -->
            <CallStatus v-if="hasSeats && currentSeat && currentSeat.link_type == 2" v-bind:SipStatus="SipStatus" :SipType="SipType" :currentSeat="currentSeat" :voipaccount="seats.length > 0 ? currentSeat.voipaccount : ''"></CallStatus>
            <!-- 预测式状态 End -->
        </div>
            

        <!-- 预测式外呼弹屏 -->
        <el-dialog title="案件信息" :visible.sync="SipShow" 
        append-to-body :before-close="handleClose" width="70%">
            <el-row class="fxn-padding-20-0">
                <el-col :span="12">案件详情（案件ID：<span class="fxn-text-blue" @click="toDetail(CaseInfo.id)" style="cursor: pointer;">{{CaseInfo.id}}</span>）查看更多信息点击案件ID</el-col>
                <el-col :span="12" class="fxn-text-right">
                    <!-- 挂机 -->
                    <span class="fxn-margin-r-20" v-if="isseatcalling">
                        繁忙中/通话中
                        <el-button type="primary" :loading="telLoading" @click="closeTel(1)">挂机</el-button>
                    </span>
                    <span class="fxn-margin-r-20" v-else></span>
                    <!-- 挂机 End -->

                    <!-- 预测式状态 -->
                    <span v-if="!isseatcalling || seatShow">
                        <CallStatus v-bind:SipStatus="SipStatus" v-bind:SipType="SipType"></CallStatus>
                    </span>
                    <!-- 预测式状态 End -->
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6" class="fxn-border-r">
                    <div class="fxn-ft-18 fxn-text-blue" v-if="wsc_encrypt == 0" @click="DataMasking">{{CaseInfo.case_name}}</div>
                    <div class="fxn-ft-18 fxn-text-blue" v-else>{{CaseInfo.case_name}}</div>
                    <div class="fxn-text-default" v-if="idcard_status">{{CaseInfo.case_phone | mobile}}</div>
                    <div class="fxn-text-default" v-else>{{CaseInfo.case_phone}}</div>
                </el-col>
                <el-col :span="6" class="fxn-border-r fxn-padding-l-20">
                    <div class="fxn-ft-14">身份证</div>
                    <div class="fxn-text-default" v-if="idcard_status">{{CaseInfo.case_idcard | idCardChange}}</div>
                    <div class="fxn-text-default" v-else>{{CaseInfo.case_idcard}}</div>
                </el-col>
                <!-- <el-col :span="6" class="fxn-border-r fxn-padding-l-20">
                    <div class="fxn-ft-14">减免状态</div>
                    <div class="fxn-text-default">{{ChangeAgiosStatus(CaseInfo.caseagios_status)}}</div>
                </el-col>
                <el-col :span="6" class="fxn-padding-l-20">
                    <div class="fxn-ft-14">跟进状态</div>
                    <div class="fxn-text-default">{{ChangeCaseStatus(CaseInfo.case_status)}}</div>
                </el-col> -->
            </el-row>

            <div class="fxn-detail-info fxn-border-t fxn-margin-t-20 fxn-padding-t-20">
                <div class="fxn-flex">
                    <!-- <div class="fxn-flex-item">合同编号：<span>{{CaseInfo.contract}}</span></div> -->
                    <div class="fxn-flex-item fxn-text-blue fxn-font-weight">产品名称：{{CaseInfo.product_name}}</div>
                    <div class="fxn-flex-item fxn-text-org fxn-font-weight">委案金额{{CaseInfo.new_entrust_money | toThousands}}</div>
                    <!-- <div class="fxn-flex-item">产品类型：<span>{{CaseInfo.product}}</span></div>
                    <div class="fxn-flex-item">贷款金额：{{CaseInfo.loan_money | toThousands}}</div> -->
                </div>
                <!-- <div class="fxn-flex">
                    <div class="fxn-flex-item fxn-text-red fxn-font-weight">逾期天数：{{CaseInfo.overdue_days}}</div>
                    <div class="fxn-flex-item fxn-text-blue fxn-font-weight">账期：{{CaseInfo.period}}</div>
                    <div class="fxn-flex-item">贷款机构：{{CaseInfo.loan_org}}</div>
                    <div class="fxn-flex-item fxn-text-blue fxn-font-weight">贷款期数：{{CaseInfo.periods}}</div>
                </div>
                <div class="fxn-flex">
                    <div class="fxn-flex-item">已还期数：<span>{{CaseInfo.per_had}}</span></div>
                    <div class="fxn-flex-item fxn-text-red fxn-font-weight">未还期数：{{CaseInfo.per_not}}</div>
                    
                    <div class="fxn-flex-item">贷款本金：<span>{{CaseInfo.loan_capital | toThousands}}</span></div>
                </div>
                <div class="fxn-flex">
                    <div class="fxn-flex-item">剩余本金：<span>{{CaseInfo.last_capital | toThousands}}</span></div>
                    <div class="fxn-flex-item">利息：<span>{{CaseInfo.interest | toThousands}}</span></div>
                    <div class="fxn-flex-item">每期还款额：<span>{{CaseInfo.per_money | toThousands}}</span></div>
                    <div class="fxn-flex-item">减免后金额：<span>{{CaseInfo.agio_money == 0 || CaseInfo.agio_money == '' ? '--' : CaseInfo.agio_money | toThousands}}</span></div>
                </div>
                <div class="fxn-flex">
                    <div class="fxn-flex-item">已调回金额：<span>{{CaseInfo.total_repay_money | toThousands}}</span></div>
                    <div class="fxn-flex-item">应还金额：<span>{{CaseInfo.amount_payable | toThousands}}</span></div>
                    <div class="fxn-flex-item fxn-text-org fxn-font-weight">剩余应还：{{CaseInfo.surplus_amount_payable | toThousands}}</div>
                    <div class="fxn-flex-item">借款日期：<span>{{CaseInfo.loan_time | dateTime}}</span></div>
                </div> -->
            </div>
            <!-- Info End -->

            <!-- Remark -->
            <div class="fxn-margin-t-20">
                <div class="fxn-title fxn-border-b">跟进结果（调解记录）</div>
                <div class="fxn-detail-remark">
                    <el-form :model="RemarkForm" :rules="RemarkRules" ref="RemarkForm" label-width="150px">
                        <el-form-item label="案件ID" prop="case_id" style="display: none;">
                            <el-input type="text" v-model="RemarkForm.case_id" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人" prop="contact_id" style="display: none;">
                            <el-input type="text" v-model="RemarkForm.contact_id" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="联系渠道" prop="contact_channel" style="display: none;">
                            <el-input type="text" v-model="RemarkForm.contact_channel" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="跟进状态" prop="status">
                            <el-radio-group v-model="RemarkForm.status" @change="handleStatus">
                                <el-radio v-for="(item,index) in noteLinkage" :key="index" :label="index">{{item.title}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item class="fxn-detail-remark-radio" label="调解状态" prop="coll_status">
                            <el-radio-group v-model="RemarkForm.coll_status" @change="handleResult(RemarkForm.coll_status,RemarkForm.status)" size="mini">
                                <el-radio border v-for="(item,index) in collStatus" :key="index" :label="index">{{item.title}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-row>
                            <template>
                                <div v-for="(list, key) in noteInput" :key="key">
                                    <el-col :span="8" v-if="list.type == 'time'">
                                        <el-form-item :label="list.title" :prop="list.name">
                                            <el-date-picker style="width: 100%" v-model="RemarkForm[list.name]" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-else-if="list.type == 'timestamp'">
                                        <el-form-item :label="list.title" :prop="list.name">
                                            <el-date-picker style="width: 100%" v-model="RemarkForm[list.name]" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-else>
                                        <el-form-item :label="list.title" :prop="list.name">
                                            <el-input type="text" v-model="RemarkForm[list.name]" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </template>
                        </el-row>
                        <el-form-item label="沟通内容" prop="notes">
                            <el-input type="textarea" v-model="RemarkForm.notes" :rows="5" placeholder="请输入沟通内容"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button :loading="loadRemark" type="primary" @click="SubmitRemark('RemarkForm')">保存调解记录</el-button>
                        </el-form-item>                
                    </el-form>
                </div>
            </div>
            <!-- Remark End -->

            <div class="fxn-tabs fxn-margin-t-20">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="调解记录" name="1"></el-tab-pane>
                    <el-tab-pane label="回款记录" name="2"></el-tab-pane>
                    <el-tab-pane label="减免记录" name="4"></el-tab-pane>
                </el-tabs>
            </div>
            <!-- Tabs End -->

            <!-- 调解记录 -->
            <div class="fxn-margin-16-0" v-show="activeName == '1'">
                <el-table v-loading="loading" :data="notes" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
                    <el-table-column label="调解时间" align="center" width="170">
                        <template slot-scope="scope">
                            {{scope.row.add_time | dateTime('1')}}
                        </template>
                    </el-table-column>
                    <el-table-column label="联络人" align="center">
                        <template slot-scope="scope">
                            {{scope.row.contacts_name}}
                            ({{scope.row.relation}})
                        </template>
                    </el-table-column>
                    <el-table-column label="联络方式" align="center" width="120">
                        <template slot-scope="scope">
                            {{scope.row.contacts_phone_all | mobile}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="跟进状态" align="center" :formatter="ChangeStatus"></el-table-column>
                    <el-table-column prop="coll_status" label="调解状态" align="center" :formatter="ChangeColl"></el-table-column>
                    <el-table-column prop="notes" label="沟通内容" align="center"></el-table-column>
                    <el-table-column prop="notes" label="承诺还款信息/备注" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.sms_repay_count">
                                <el-button class="fxn-text-blue" type="text" @click="getSmsRepay(scope.row.id)">接收方短信回复</el-button>
                            </div>
                            <span v-else-if="scope.row.status == 2">
                                <span v-if="scope.row.coll_status == 1">
                                    承诺在{{scope.row.promise_time | dateTime}}前还款{{scope.row.promise_money}}元
                                </span>
                                <span v-else-if="scope.row.coll_status == 3">
                                    承诺分{{scope.row.promise_periods}}还款，{{scope.row.promise_per_day}}还{{scope.row.promise_per_money}}”
                                </span>
                                <span v-else-if="scope.row.coll_status == 4">
                                    另约{{scope.row.order_time | dateTime(1)}}进行沟通
                                </span>
                                <span v-else>--</span>
                            </span>
                            <span v-else-if="scope.row.status == 8">
                                <span v-if="scope.row.repay_status == 2">{{scope.row.repay_time | dateTime}}部分还款{{scope.row.repay_money}}元</span>
                                <span v-else>--</span>
                            </span>
                            <span v-else-if="scope.row.status == 9">
                                <span v-if="scope.row.repay_status == 2">{{scope.row.repay_time | dateTime}}结清还款{{scope.row.repay_money}}元</span>
                                <span v-else>--</span>
                            </span>
                            <span v-else>
                                --
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="add_name" label="调解员" align="center"></el-table-column>
                    <el-table-column prop="contact_channel" label="联系渠道" align="center" :formatter="ChangeChannel"></el-table-column>
                </el-table>
            </div>
            <!-- 调解记录 End -->

            <!-- 回款记录 -->
            <div class="fxn-margin-16-0" v-show="activeName == '2'">
                <!-- <div class="fxn-margin-16-0">
                    <el-select v-model="tostatus" placeholder="请选择" @change="onRepay">
                        <el-option v-for="item in reStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div> -->
                <div>终审通过还款金额合计：{{repay_total | toThousands}}元</div>

                <el-table v-loading="loading" :data="repayments" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
                    <el-table-column label="登记时间" align="center" width="170">
                        <template slot-scope="scope">
                            {{scope.row.add_time | dateTime('1')}}
                        </template>
                    </el-table-column>
                    <el-table-column label="还款时间" align="center">
                        <template slot-scope="scope">
                            {{scope.row.repay_time | dateTime}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="repay_money" label="还款金额" align="center">
                        <template slot-scope="{ row }">
                            {{ row.repay_money | toThousands }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="repay_channel" label="还款方式" align="center"></el-table-column>
                    <el-table-column label="订单号/还款卡号" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.repay_channel == '银联还款'">
                                {{scope.row.repay_account}}
                                <span v-if="scope.row.repay_account1">**** {{scope.row.repay_account1}}</span>
                            </span>
                            <span v-else>
                                {{scope.row.repay_orderno}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="repay_account_name" label="转账人姓名" align="center"></el-table-column>
                    <el-table-column prop="repay_status" label="还款类型" align="center" :formatter="changeRepay"></el-table-column>
                    <el-table-column label="审核状态" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.repaystatus != 3">{{RepaymentStatus(scope.row.repaystatus,scope.row.hexiao)}}</span>
                            <el-popover v-if="scope.row.repaystatus == 3" title="拒绝原因：" placement="top-start" width="200" trigger="hover" :content="scope.row.verify_remark">
                                <el-button type="text" slot="reference">{{RepaymentStatus(scope.row.repaystatus)}}</el-button>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button type="text" @click="OpenDetail(scope.row.repay_voucher)">查看还款凭证</el-button>
                            <el-popover v-if="scope.row.verify_remark != ''" title="查看原因" placement="top-start" width="200" trigger="hover" :content="VerifyRepay(scope.row.verify_fail) + '：' + scope.row.verify_remark">
                                <el-button type="text" slot="reference">查看原因</el-button>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 回款记录 End -->

            <!-- 减免记录 -->
            <div class="fxn-margin-16-0" v-show="activeName == '4'">
                <el-table v-loading="loading" :data="agios" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
                    <el-table-column label="申请时间" align="center">
                        <template slot-scope="scope">
                            {{scope.row.add_time | dateTime('1')}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="add_name" label="申请人" align="center"></el-table-column>
                    <el-table-column prop="reason" label="申请原因" align="center"></el-table-column>
                    <el-table-column prop="agio_money" label="减免后金额" align="center">
                        <template slot-scope="{ row }">
                            {{ row.agio_money | toThousands }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="申请状态" align="center" :formatter="ChangeAgioStatus"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row.verify_remark != '' && (scope.row.status == 3 || scope.row.status == 5 || scope.row.status == 6)" title="查看原因" placement="top-start" width="200" trigger="hover" :content="VerifyFail(scope.row.verify_fail) + '：' + scope.row.verify_remark">
                                <el-button type="text" slot="reference">查看原因</el-button>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 减免记录 End -->

            <!-- 查看还款凭证 -->
            <el-dialog title="查看还款凭证" :visible.sync="dialogVisible" width="50%" append-to-body>
                <el-carousel indicator-position="outside">
                    <el-carousel-item v-for="(item,index) in PayMentImg" :key="index" class="fxn-text-center">
                        <img :src="TextUrl + item" alt="" srcset="" style="max-width: 100%;max-height: 100%">
                    </el-carousel-item>
                </el-carousel>
            </el-dialog>
            <!-- 查看还款凭证 End -->
            <!-- 接收方短信回复 -->
            <SmsRepay :smsRepayObj="smsRepayObj"></SmsRepay>
            <!-- 接收方短信回复 END -->
        </el-dialog>
        <!-- 预测式外呼弹屏 End -->

        <!-- 关闭弹屏-->
        <el-dialog title="提示" :visible.sync="tipsShow" 
        append-to-body :before-close="tipsClose" width="30%">
            <div class="fxn-text-center">关闭该弹窗后，通话则将挂断, 是否继续?</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="tipsClose">取 消</el-button>
                <el-button type="primary" @click="closeTel">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 关闭弹屏 End-->

        <!-- 来电用户数据弹屏 -->
        <el-dialog class="callLT-wrap" title="来电弹屏" :visible.sync="callLTopen" 
        append-to-body :close-on-click-modal="false" :before-close="callLTopenFormCancel" width="800px">
            <el-table :data="callLTdata" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
                <el-table-column label="id" prop="id" align="center"></el-table-column>
                <el-table-column label="客户名称" prop="case_name" align="center"></el-table-column>
                <el-table-column label="联系电话" prop="case_phone" align="center"></el-table-column>
                <el-table-column label="产品名称" prop="product_name" align="center"></el-table-column>
                <el-table-column label="委案金额" prop="entrust_money" align="center">
                    <template slot-scope="{ row }">
                        {{ row.entrust_money | toThousands }}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="剩余本金" prop="remain_money" align="center"></el-table-column>
                <el-table-column label="贷款时间" prop="loan_time" align="center"></el-table-column>
                <el-table-column label="逾期时间" prop="over_time" align="center"></el-table-column> -->
            </el-table>
            <el-form :model="callLTopenForm" ref="callLTopenForm" >
                <el-form-item label="备注" prop="content">
                    <el-input type="textarea" v-model="callLTopenForm.content" :rows="5" maxlength="500" show-word-limit placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div class="last-time">
                <div class="title" style="font-weight: 500">上一次沟通记录:</div>
                <p class="content" style="line-height: 20px;text-indent: 2em">{{ lastRemark || ''}}</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="callLTopenFormCancel">取 消</el-button>
                <el-button type="primary" :loading="callLTopenFormLoading" @click="submitCallLTopenForm">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 来电弹屏 -->
        <InCallDialog ref="InCallDialogRef" :wsc_encrypt="wsc_encrypt" />
        <!-- 工作手机来电弹屏 -->
        <PhoneInCallDialog ref="PhoneInCallDialogRef" :wsc_encrypt="wsc_encrypt" />
    </div>
</template>

<script>
    let ws= '';
    import CallStatus from './AiSip/CallStatus.vue'
    import CallTabs from './AiSip/CallTabs.vue'
    import SmsRepay from '../components/SmsRepay.vue'
    import InCallDialog from './AiSip/InCallDialog.vue';
    import PhoneInCallDialog from './AiSip/PhoneInCallDialog.vue';
    export default {
        components: {
            CallStatus,
            CallTabs,
            SmsRepay,
            InCallDialog,
            PhoneInCallDialog
        },
        computed: {
            isseatcalling() {
                return this.$store.getters.iscalling || this.$store.getters.isincall
            },
            currentSip() {
                return this.$store.getters.currentSip || this.currentSeat
            }
        },
        data(){
            return{
                winShow: false,
                SipShow: false,
                memberInfo: {},
                SipStatus: "1",
                SipPop: {},
                case_id: '',

                loading: false,
                telLoading: false,
                wsc_encrypt: '',
                idcard_status: true,
                seatShow: false,
                SipType: true,
                CaseInfo: [],
                StatusData: [
                    {value: 1, label: '待跟进'},
                    {value: 2, label: '重点跟进'},
                    {value: 3, label: '承诺还款'},
                    {value: 4, label: '失联跟进'},
                    {value: 5, label: '每日跟进'},
                    {value: 6, label: '沟通无果'},
                    {value: 7, label: '难联户'},
                    {value: 8, label: '部分还款'},
                    {value: 9, label: '结清还款'},
                    {value: 10, label: '申请发函'},
                    {value: 11, label: '发送短信'},
                    {value: 12, label: '发送邮件'},
                    {value: 99, label: '特殊状态'},
                ],

                //关闭弹屏
                tipsShow: false,
                // popStatus: false,

                //Tabs
                activeName: '1',
                notes: [],
                repayments: [],
                agios: [],
                contactChannel: [],
                CollType: [],

                //回款记录
                repay_total: '',
                tostatus: '',
                reStatus: [],
                
                //凭证阅览
                PayMentImg: [],
                dialogVisible: false,

                //接收方短信回复
                smsRepayObj: {
                    SmsRepayWin: false,
                    SmsRepayData: [],
                    Smsloading: false,
                },

                //跟进结果
                loadRemark: false,
                RemarkForm: {
                    case_id: '',
                    status: '2',
                    contact_id: '',
                    contact_channel: '',
                    coll_status: '',
                    notes: '',
                    order_time: '',
                    promise_time: '',
                    promise_money: '',
                    promise_per_day: '',
                    promise_periods: '',
                    promise_per_money: '',
                },
                RemarkRules: {
                    status: [
                        { required: true, message: '请选择跟进状态', trigger: 'blur' }
                    ],
                    coll_status: [
                        { required: true, message: '请选择调解状态', trigger: 'blur' }
                    ]  
                },
                noteLinkage: [],
                collStatus: [],
                noteInput: [],
                
                wsissend: false, //长链是否请求

                callLTopen: false,
                callLTdata: [],
                callLTopenForm: {
                    client_log_ids: '',
                    content: ''
                },
                callLTopenFormLoading: false,
                seats: [],
                currentSeat: null,
                hasSeats: false,
                lastRemark: null,
            }
        },
        methods:{
            handleSwitchSip(row) {
                if (!this.$store.getters.isRegistered) {
                    this.$message({
                        message: '请先登录SIP',
                        type: 'warning'
                    })
                    return
                }
                this.currentSeat = row;
                webrtcSDK.switchSip({
                    user: row.voipaccount,
                    password: row.voippwd,
                    current_line_type: row.link_type
                });
            },
            //判断是否有坐席
            getSip(){
                this.get('/ycapi/seat/get_sip_status')
                .then(res=> {
                    let { code  , msg ,data} = res.data
                    if( code != 1){
                        if(code == 1002){
                            this.seatShow = false;
                        }else{
                            this.$message({
                                message: msg,
                                type:'error'
                            })
                        }
                    }else{
                        this.seatShow = true;
                    }
                })
            },

            //预测式webscoket数据接口
            SeatWebscoket(){
                let _this = this;
                ws = new WebSocket(this.WebSocketUrl);
                let user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    _this.member_id = user.memberInfo.id
                }
                ws.onopen = function() {
                    ws.send('{"cmd":"zwscallScreen","member_id":"'+ _this.member_id +'"}');
                };

                ws.onmessage = function (e) {
                    console.log("JSON.parse(e.data):")
                    console.log(JSON.parse(e.data))

                    let data = JSON.parse(e.data);
                    let { screenType, screenData } = data;
                    if (screenType == 1) { // 来电弹屏
                        _this.get('osapi/Cases/getCaseIdListByPhone', {
                            phone: screenData.phone
                        }).then(res => {
                            console.log(res)
                            let { code, msg, data } = res.data;
                            if (code != 1) {
                                _this.$message({
                                    message: msg,
                                    type: 'error'
                                });
                            } else {
                                if (data.caseIdList && data.caseIdList.length != 0 && data.caseIdList != '') {
                                    _this.$refs.InCallDialogRef.opendialog(data.caseIdList, screenData.phone);
                                }
                                
                            }
                        })
                    } else { //预测式外呼弹屏
                        _this.case_id = screenData.caseId;
                        _this.getCase();
                        _this.getContact();
                        _this.SipShow = true; 
                    }   
                };
                ws.onclose = function (event) {
                    // 重新发起
                    _this.SeatWebscoket();
                }          
            },

            //工作手机来电弹屏
            PhoneWebscoket(){
                let _this = this;
                ws = new WebSocket(this.WebSocketUrl);
                let user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    _this.member_id = user.memberInfo.id
                }
                ws.onopen = function() {
                    ws.send('{"cmd":"ykcallScreen","member_id":"'+ _this.member_id +'"}');
                };

                ws.onmessage = function (e) {
                    console.log("JSON.parse(e.data):")
                    console.log(JSON.parse(e.data))

                    let data = JSON.parse(e.data);
                    let { screenType, screenData } = data;
                    _this.get('osapi/Cases/getCaseIdListByPhone', {
                        phone: screenData.clientPhone
                    }).then(res => {
                        console.log(res)
                        let { code, msg, data } = res.data;
                        if (code != 1) {
                            _this.$message({
                                message: msg,
                                type: 'error'
                            });
                        } else {
                            if (data.caseIdList && data.caseIdList.length != 0 && data.caseIdList != '') {
                                _this.$refs.PhoneInCallDialogRef.opendialog(data.caseIdList, screenData.clientPhone);
                            }
                            
                        }
                    })  
                };
                ws.onclose = function (event) {
                    // 重新发起
                    _this.SeatWebscoket();
                }          
            },

            // 获取坐席状态
            getSeatStatus() {
                if (this.currentSeat.link_type != 2) {
                    return
                }
                this.post('osapi/Intelligence/getSeatState', {
                    voipaccount: this.currentSeat.voipaccount
                }).then(res => {
                    let { code, data, msg } = res.data;
                    if (code !== 1) {
                        this.$message({
                            message: msg,
                            type: 'error'                            
                        });
                    } else {
                        this.SipStatus = data.state
                    }
                })
            },

            //Tabs
            handleClick(){
                this.getWorks();
            },

            //选择回款记录
            onRepay(){
                this.getWorks(this.tostatus);
            },

            //获取Tabs
            getWorks(status){
                this.loading = true;
                this.get('/osapi/Cases/caseWork',{
                    case_id: this.case_id,
                    work_type: this.activeName,
                    status: status
                })
                .then(res=>{
                    let { code  , msg ,data} = res.data
                    if( code != 1){
                        this.$message({
                            message:msg,
                            type:'error'
                        })
                    }else{
                        this.notes = res.data.data.notes;
                        this.repayments = res.data.data.repayments;
                        this.agios = res.data.data.agios;
                        this.repay_total = res.data.data.repay_total;
                    }
                    this.loading = false;
                })
            },

            //接收方短信回复
            getSmsRepay(id) {
                this.get('/osapi/Cases/getCaseNotesSmsRepay',{
                    note_id: id
                }).then( res => {
                    let { code , msg , data } = res.data;
                    if (code != 1) {
                        this.$message({
                            type: 'error',
                            message: msg
                        })
                        this.smsRepayObj.Smsloading = false;
                    } else {
                        this.smsRepayObj.SmsRepayWin = true;
                        this.smsRepayObj.SmsRepayData = res.data.data.sms_repay_list;
                        this.smsRepayObj.Smsloading = false;
                    }
                })
            },

            //获取渠道
            getConfigList(){
                this.get('/osapi/Config/confList')
                .then( res => {
                    let { msg, code, data } = res.data
                    if( code !== 1 ){
                        this.$message({
                            message : msg,
                            type: 'error'
                        })
                    }else{
                        this.contactChannel = res.data.data;
                        for (let key = 0; key < this.contactChannel.length; key++) {
                            if(this.contactChannel[key].title == '电话'){
                                this.RemarkForm.contact_channel = this.contactChannel[key].id
                            }
                        }
                        if(this.contactChannel.length < 1){
                            this.$message({
                                message: '请先添加联系渠道!',
                                type: 'error'
                            }); 
                            return false;
                        }
                    }
                })
            },

            //获取详情
            getCase(){
                this.get('/osapi/Cases/caseInfo',{
                    id: this.case_id
                })
                .then(res=> {
                    let { msg, code, data} = res.data
                    if( code != 1){
                        this.$message({
                            message: msg,
                            type: "error"
                        });
                    }else{
                        this.CaseInfo = res.data.data.data;
                        this.getWorks();
                    }
                })
            },

            //修改弹屏状态
            getPop(){
                this.get('/ycapi/agent/update_pop')
                .then(res=> {
                    let{ msg, code, data } = res.data
                    if( code == 0 ){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                        return false;
                    }else{
                        
                    }
                })
            },

            //挂机
            closeTel(type){
                // this.telLoading = true;
                // this.post('/ycapi/agent/agent_status_update',{
                //     type: 5,
                // })
                // .then(res=> {
                //     let{ msg, code, data } = res.data
                //     if( code != 1 ){
                //         if( code == 1002 ){
                //             this.$message({
                //                 message: msg,
                //                 type: 'warning'
                //             });
                //         }else{
                //             this.$message({
                //                 message: msg,
                //                 type: 'error'
                //             });
                //         }
                //         this.telLoading = false;
                //         return false;
                //     }else{
                //         this.telLoading = false;
                //         if(type != 1){
                //             this.SipShow = false;
                //         }
                //         this.tipsShow = false;
                //         this.$message({
                //             type: 'success',
                //             message: '操作成功!'
                //         });
                //     }
                // })
                webrtcSDK.endCall()
            },

            //选择跟进状态
            handleStatus(){
                this.collStatus = [];
                this.noteInput = []; 
                this.RemarkForm.notes = '';
                for (var key in this.noteLinkage){
                    if (key === this.RemarkForm.status){
                        this.collStatus = this.noteLinkage[key].sub;
                        break;
                    }
                }
                this.RemarkForm.coll_status = '';
                for (var collKey in this.collStatus){
                    if (collKey === key){
                        this.noteInput = this.collStatus[collKey].sub
                        break;
                    }
                }
            },

            //选择调解状态
            handleResult(status){
                this.noteInput = [];
                for (var collKey in this.collStatus){
                    if (collKey === this.RemarkForm.coll_status){
                        this.noteInput = this.collStatus[collKey].sub
                        break;
                    }
                }
                //失联跟进状态默认给催记内容覆值
                if(status == 4){
                    for(let collkey in this.collStatus){
                        if(this.RemarkForm.coll_status == collkey){                        
                            this.RemarkForm.notes = this.collStatus[collkey]['title']
                        }
                    }
                }
            },

            //获取催记状态
            getnoteOp(){
                this.get('/osapi/overdue/noteOp')
                .then( res=>{
                    let { code  , msg ,data} = res.data;
                    if( code != 1){
                        this.$message({
                            message:msg,
                            type:'error'
                        })
                    }else{
                        this.noteLinkage = res.data.data.noteLinkage;
                        this.handleStatus();
                        this.handleResult();
                    }
                })
            },

            //提交跟进状态
            SubmitRemark(formName){
                let numbers = /^[1-9]\d*$/;
                let twonumber = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.RemarkForm.coll_status == 1){
                            if(!this.RemarkForm.promise_time){
                                this.$message({ 
                                    message : '请选择承诺还款时间',
                                    type: 'error'
                                })
                                return
                            }
                            if(this.RemarkForm.promise_money == ''){
                                this.$message({
                                    message : '请输入承诺还款金额',
                                    type: 'error'
                                })
                                return
                            }else if(!twonumber.test(this.RemarkForm.promise_money)){
                                this.$message({
                                    message : '承诺还款金额格式不正式;如25000',
                                    type: 'error'
                                })
                                return
                            }
                        }

                        if(this.RemarkForm.coll_status == 3){
                            if(!this.RemarkForm.promise_periods){
                                this.$message({
                                    message : '请输入承诺分期数',
                                    type: 'error'
                                })
                                return
                            }else if(!numbers.test(this.RemarkForm.promise_periods)){
                                this.$message({
                                    message : '承诺分期数格式不正确;如:20',
                                    type: 'error'
                                })
                                return
                            }
                            if(!this.RemarkForm.promise_per_money){
                                this.$message({
                                    message : '请输入承诺每期还款金额',
                                    type: 'error'
                                })
                                return
                            }else if(!twonumber.test(this.RemarkForm.promise_periods)){
                                this.$message({
                                    message : '承诺每期还款金额格式不正确;如:20.00',
                                    type: 'error'
                                })
                                return
                            }
                            if(!this.RemarkForm.promise_per_day){
                                this.$message({
                                    message : '请输入承诺每期还款日期',
                                    type: 'error'
                                })
                                return
                            }else if(!numbers.test(this.RemarkForm.promise_per_day)){
                                this.$message({
                                    message : '承诺每期还款日期格式不正确;如:20',
                                    type: 'error'
                                })
                                return
                            }
                        }

                        if(this.RemarkForm.coll_status == 4){
                            if(!this.RemarkForm.order_time){
                                this.$message({
                                    message : '请选择另约时间',
                                    type: 'error'
                                })
                                return
                            }
                        }

                        this.loadRemark = true;

                        this.post('/osapi/Overdue/noteOp',{
                            case_id: this.case_id,
                            contact_id: this.RemarkForm.contact_id,
                            status: this.RemarkForm.status == '1' ? '5' : this.RemarkForm.status,
                            coll_status: this.RemarkForm.coll_status,
                            notes: this.RemarkForm.notes,
                            promise_time: this.RemarkForm.promise_time,
                            promise_money: this.RemarkForm.promise_money,
                            promise_periods: this.RemarkForm.promise_periods,
                            promise_per_money: this.RemarkForm.promise_per_money,
                            promise_per_day: this.RemarkForm.promise_per_day,
                            order_time: this.RemarkForm.order_time,
                            contact_channel: this.RemarkForm.contact_channel,
                        })
                        .then( res=>{
                            let { msg, code, data } = res.data
                            if( code !== 1 ){
                                this.$message({
                                    message : msg,
                                    type: 'error'
                                })
                            }else{
                                this.$message({
                                    message : '提交成功!',
                                    type: 'success'
                                })
                                this.noteInput = [];
                                this.RemarkForm.notes = '';
                                this.RemarkForm.coll_status = '';
                                this.RemarkForm.order_time = '';
                                this.RemarkForm.promise_time = '';
                                this.RemarkForm.promise_money = '';
                                this.RemarkForm.promise_per_day = '';
                                this.RemarkForm.promise_periods = '';
                                this.RemarkForm.promise_per_money = '';
                                this.OpenAside.$emit('CheckRemark',true);
                            }
                        }).finally(() => {
                            this.loadRemark = false;
                        })
                    }
                })
            },

            //获取联系人键值
            getContact(){
                this.get('/osapi/Overdue/contacts',{
                    is_page: 0,
                    case_id: this.case_id,
                })
                .then( res=>{
                    let { msg, code, data } = res.data;
                    if( code !== 1 ){
                        this.$message({
                            message : msg,
                            type: 'error'
                        })
                    }else{
                        this.RemarkForm.contact_id = res.data.data[0].id;
                    }
                })
            },

            //跳转详情
            toDetail(id) {
                this.$router.push({ 
                    path: '/CaseDetail/' + id, 
                    query: {
                        id: id,
                        noncollector: true
                    } 
                })
                // this.$router.push({ 
                //     path: '/CaseInfo/'+id, 
                //     query: {
                //         id:id,
                //         listId: 0,
                //         callshow: true,
                //         detailtype: true
                //     } 
                // })
                this.SipShow = false
                // window.open('index.html#/CaseInfo/' + id + '?id=' + id + '&listId=0&callshow=' + true + '&detailtype=' + true)
                // window.open('index.html#/CaseDetail?id=' + id + '&noncollector=true');
            },

            //关闭弹窗
            handleClose(){
                this.SipShow = false;
                if(this.isseatcalling){
                    this.tipsShow = true;
                }else{
                    this.tipsShow = false;
                }
            },

            //取消关闭提示
            tipsClose(){
                this.tipsShow = false;
                this.SipShow = true;
            },

            //数据脱敏
            DataMasking(){
                this.idcard_status = !this.idcard_status;
            },

            //减免状态
            ChangeAgiosStatus(status){
                if(status == 0){
                    return '未申请'
                }else if(status == 1){
                    return '待审核'
                }else if(status == 2){
                    return '已减免'
                }else if(status == 3){
                    return '审核未通过'
                }else if(status == 4){
                    return '待终审'
                }
            },

            //跟进状态
            ChangeCaseStatus(case_status){
                for (let index = 0; index < this.StatusData.length; index++) {
                    if(parseInt(case_status) == this.StatusData[index].value){
                        return this.StatusData[index].label;
                    }
                }
            },


            //查看
            OpenDetail(repay_voucher){
                this.dialogVisible = true;
                this.PayMentImg = repay_voucher.split(',')
            },

            //跟进状态
            ChangeStatus(row){
                for (let index = 0; index < this.StatusData.length; index++) {
                    if(row.status == this.StatusData[index].value){
                        return this.StatusData[index].label;
                    }
                }
            },

            //调解状态
            ChangeColl(row){
                if (row.is_import == 1) {
                    return row.coll_status_title;
                } else {
                    for (let key in this.noteLinkageData) {
                        if (row.coll_status == key) {
                            return this.noteLinkageData[key];
                        }
                    }
                }
            },

            //联系渠道
            ChangeChannel(row){
                for(let key in this.contactChannel){
                    if(row.contact_channel == this.contactChannel[key].id){
                        return this.contactChannel[key].title;
                    }
                }
            },

            //还款类型
            changeRepay(row){
                switch(parseInt(row.repay_status)){
                    case 8:
                        return '部分还款'
                    case 9:
                        return '结清还款'
                }
            },

            //减免状态
            ChangeAgioStatus(row){
                switch(parseInt(row.status)){
                    case 1:
                        return '未处理'
                    case 2:
                        return '通过'
                    case 3:
                        return '拒绝'
                    case 4:
                        return '待终审'
                    case 5:
                        return '拒绝'
                }
            },

            //减免--拒绝原因状态
            VerifyFail(type){
                switch(parseInt(type)){
                    case 1:
                        return '超过减免比例'
                    case 2:
                        return '减免资料缺失'
                    case 3:
                        return '减免资料错误'
                    case 4:
                        return '金额错误'
                    case 5:
                        return '拒绝'
                    case 6:
                        return '结清还款时提交申请'
                }
            },

            //回款记录--审核状态
            RepaymentStatus(repaystatus,hexiao){
                if(repaystatus == 1){
                    return '待审核'
                }else if(repaystatus == 2){
                    if(hexiao == 1){
                        return '核销通过'
                    }else{
                        return '已通过'
                    }                    
                }else if(repaystatus == 3){
                    return '初审不通过'
                }else if(repaystatus == 4){
                    return '初审通过'
                }else if(repaystatus == 5){
                    return '终审不通过'
                }else if(repaystatus == 6){
                    return '已撤销'
                }
            },

            //回款拒绝原因
            VerifyRepay(type){
                if(type ==1 ){
                    return '无凭证'
                }else if(type ==2){
                    return '凭证错误'
                }else if(type == 3){
                    return '未收到'
                }
            },

            //来电弹屏
            OpenLT(user){
                let _this = this
                if (user) {
                    _this.member_id = user.memberInfo.id
                } else {
                    return
                }
                const ws = new WebSocket(this.WebSocketUrl);
                ws.onopen = function() {
                    ws.send('{"cmd":"cc_call","member_id":"'+ _this.member_id +'"}');
                };
                ws.onmessage = function(e) {
                    const res = JSON.parse(e.data);
                    if (res.hasOwnProperty('status')) {
                        _this.SipStatus = res;
                    } else if (res.hasOwnProperty('id') && res.id && String(res.id) !== '0') {
                        _this.post("/call/client/clientLogList", {
                            ids: res.id
                        }).then(res => {
                            _this.callLTdata = res.data.data.logs || [];
                            _this.lastRemark = res.data.data.lastRemark || null
                            _this.callLTopen = true;
                        })
                    }
                };
                ws.onclose = function (event) {
                    console.log(event)
                }
            },

            callLTopenFormCancel() {
                if (this.$refs.callLTopenForm) {
                    this.$refs.callLTopenForm.resetFields()
                }
                this.lastRemark = null
                this.callLTopenForm = {
                    client_log_ids: '',
                    content: ''
                }
                this.lastRemark = null;
                this.callLTopen = false
            },

            submitCallLTopenForm() {
                if (this.callLTdata.length === 0 || this.callLTopenForm.content === '') {
                    this.callLTopenFormCancel(); 
                } else {
                    this.callLTopenFormLoading = true;
                    this.callLTopenForm.client_log_ids = String(this.callLTdata.map(item => item.id));
                    this.$http.post(`${this.TextUrl}call/client/addRemark`, this.callLTopenForm).then(res => {
                        let { code, msg } = res.data;
                        if (code != 1) {
                            this.$message({
                                type: 'error',
                                message: msg
                            })
                        } else {
                            this.$message({
                                type: 'success',
                                message: '操作成功'
                            })
                            this.callLTopenFormCancel(); 
                        }
                    }).finally(() => {
                        this.callLTopenFormLoading = false;
                    })
                }
            }
        },
        watch: {
            seatShow(val) {
                let user = JSON.parse(localStorage.getItem('user'));
                if (val && user.memberInfo.mem_type != 1 && !this.wsissend && this.memberInfo.ver_type != '7') {
                    this.wsissend = true
                    this.SeatWebscoket();
                    let obj = {
                        WebSocketUrl: this.WebSocketUrl,
                        member_id: user.memberInfo.id
                    }
                    this.$store.dispatch('call/initSeatStatusWs', obj)
                }
            },
            SipShow(val) {
                if (!val) {
                    this.OpenAside.$off('CheckRemark');
                }
            },
            currentSip(val) {
                console.log(val)
                if (val && this.currentSeat.voipaccount != val) {
                    console.log(this.$store.getters.currentSip)
                    let currentSeatArr = this.seats.filter(item => item.voipaccount == this.$store.getters.currentSip)
                    console.log(currentSeatArr)
                    if (currentSeatArr && currentSeatArr.length > 0) {
                        this.handleSwitchSip(currentSeatArr[0])
                    }
                }
            }
        },
        created() {
            
        },
        mounted(){
            let user = JSON.parse(localStorage.getItem('user'));
            this.memberInfo = user.memberInfo;
            if(this.memberInfo.mem_type != 1 && this.memberInfo.ykWorkPhoneInfo){
                this.PhoneWebscoket();
            }
            if(user){
                this.wsc_encrypt = user.memberInfo.wsc_encrypt;
            }
            let that = this;
            this.OpenAside.$on('CheckRemark',function(type){
                that.getCase();
            })
            this.getnoteOp();
            this.getConfigList();
            if (String(user.memberInfo.ver_type) !== '7') { //7: 呼叫中控台的用户
                this.getSip();
            } else {
                this.OpenLT(user);
            }
            this.hasSeats = user.memberInfo.seats.length > 0
            this.seats = user.memberInfo.seats || []
            if (this.hasSeats) {
                if (this.seats.length === 1) {
                    this.currentSeat = this.seats[0]
                } else {
                    this.currentSeat = this.seats.filter(item => item.link_type == 1)[0]
                }
                
            }
            // this.getSip();

            //获取催记状态
            this.CollType = JSON.parse(sessionStorage.getItem('noteLinkage'));
            if (this.memberInfo.seats.length > 0 && this.currentSeat && this.currentSeat.link_type == 2) {
                this.getSeatStatus()
            }
        }
    }
</script>

<style scoped>
/* /deep/.callLT-wrap .el-dialog {
    left: -20px;
} */
.item {
    height: 4rem;
}
.switch-sip-wrap {
    margin-top: -1rem;
    height: 4rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/AiSip.vue